import { render, staticRenderFns } from "./ReportGlobalvalueRecordShop.vue?vue&type=template&id=54974346&scoped=true&"
import script from "./ReportGlobalvalueRecordShop.vue?vue&type=script&lang=js&"
export * from "./ReportGlobalvalueRecordShop.vue?vue&type=script&lang=js&"
import style0 from "./ReportGlobalvalueRecordShop.vue?vue&type=style&index=0&id=54974346&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54974346",
  null
  
)

export default component.exports